import {
  REQUEST_CURRENT_USER_DETAILS,
  FAIL_RECEIVE_CURRENT_USER_DETAILS,
  RECEIVE_CURRENT_USER_DETAILS,
 } from 'shared/actionTypes';

function details(state = {}, action) {
  switch (action.type) {
  case RECEIVE_CURRENT_USER_DETAILS:
    return Object.assign({}, state, action.payload.currentUserDetails);
  default:
    return state;
  }
}

export default function currentUser(state = {
  isError: false,
  isFetching: false,
}, action) {
  switch (action.type) {
  case REQUEST_CURRENT_USER_DETAILS:
    return Object.assign({}, state, {
      isFetching: true,
    });
  case FAIL_RECEIVE_CURRENT_USER_DETAILS:
    return Object.assign({}, state, {
      isError: true,
      isFetching: false,
    });
  case RECEIVE_CURRENT_USER_DETAILS:
    return Object.assign({}, state, {
      details: details(state.details, action),
      isFetching: false,
    });
  default:
    return state;
  }
}
